import React from "react";
import { useLocation } from "react-router-dom";
import { AgentPanel } from "llmasaservice-ui";
import { Helmet } from "react-helmet";

const EmbedAgentComponentNew: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id") || "";
  const customer_id = searchParams.get("customer_id") || "";
  const customer_email = searchParams.get("customer_email") || "";

  let url = "https://chat.llmasaservice.io/";
  // if the url is localhost or dev.llmasaservice.io, we are in development mode and we should use the dev endpoint
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "dev.llmasaservice.io"
  ) {
    url = "https://chat.llmasaservice.io/dev";
  }

  return (
    <>
      <Helmet>
        <base target="_blank" />
        <link
          rel="iframely reader resizable"
          type="text/html"
          href={`https://app.llmasaservice.io/embedagent?id=${id}&customer_id=&customer_email=`}
          media="height: 600"
        />
      </Helmet>

      {(customer_id !== "" || customer_email !== "" )? (
        <AgentPanel
          agent={id}
          url={url}
          customer={{ 
            customer_id: customer_id,
            customer_user_id: customer_email,
            customer_user_name: customer_email,
          }}
        />
      ) : (
        <AgentPanel agent={id} url={url} />
      )}
    </>
  );
};

export default EmbedAgentComponentNew;
